import { hostsSliceActions } from '@/modules/host/slice';
import { AnyAction, Dispatch } from '@reduxjs/toolkit';
import { CMDScHostSetting } from '../live/CMDScHostSetting';
import { ICommand } from '../live/ICommand';
import { AbstractHandler } from './AbstractHandler';

export class CMDScHostSettingHandler extends AbstractHandler {
    _command: CMDScHostSetting;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScHostSetting;
    }
    handle(dispatch: Dispatch<AnyAction>): void {
        dispatch(
            hostsSliceActions.updateHostSetting({
                hostId: this._command.HostID,
                HostMsg: this._command.HostMsg,
            })
        );
    }
}
